import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbVersionInfoFactory;
/* eslint-disable */
/**
 * AbWeb
 * Core Ab Initio platform services
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/absdk/typescript/target/openapi/openapi//commons/core.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { AbSemanticVersionNumberFactory } from "./AbSemanticVersionNumber";

/**
 * Version information for an Ab Initio API.
 * @export
 * @interface AbVersionInfo
 */

export class AbVersionInfoFactory {}
_AbVersionInfoFactory = AbVersionInfoFactory;
_defineProperty(AbVersionInfoFactory, "FromJSON", function (json) {
  return _AbVersionInfoFactory.FromJSONTyped(json, false);
});
_defineProperty(AbVersionInfoFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'semanticVersionNumber': AbSemanticVersionNumberFactory.FromJSON(json['semanticVersionNumber']),
    'versionNumber': json['versionNumber'],
    'compatibility': json['compatibility']
  };
});
_defineProperty(AbVersionInfoFactory, "ToJSON", function (value) {
  return _AbVersionInfoFactory.ToJSONTyped(false, value);
});
_defineProperty(AbVersionInfoFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'semanticVersionNumber': AbSemanticVersionNumberFactory.ToJSON(value.semanticVersionNumber),
    'versionNumber': value.versionNumber,
    'compatibility': value.compatibility
  };
});
//# sourceMappingURL=AbVersionInfo.js.map
